import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'dark-900' | 'dark-800' | 'dark-700';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'dark-900'
}: SectionProps) {
  const bgColors = {
    'dark-900': 'bg-dark-900',
    'dark-800': 'bg-dark-800',
    'dark-700': 'bg-dark-700'
  };
  return <section id={id} className={`py-6 md:py-20 lg:py-28 ${bgColors[bg]} ${className}`} data-id="element-381">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-382">
        {children}
      </motion.div>
    </section>;
}